<h3
  class="loading-pipelines text-center"
  *ngIf="!activeMasterPipeline && !activePipeline"
  ><i class="fas fa-spinner fa-spin"></i> Loading pipelines...</h3
>

<!-- <h3 class="loading-pipelines text-center text-warning" *ngIf="!loadingPipelines && pipelines.length == 0">No pipelines set.</h3> -->

<div class="kt-widget filter mb-0" *ngIf="activePipeline || activeMasterPipeline">
  <div class="pull-right pipeline-completion">
    <h3 class="text-success" *ngIf="activePipeline">
      <ng-container
        *ngTemplateOutlet="
          completionStatus;
          context: {
            pipeline: activePipeline,
          }
        "
      >
      </ng-container>
    </h3>
    <h3 class="text-success" *ngIf="activeMasterPipeline && !activePipeline">
      <ng-container
        *ngTemplateOutlet="
          completionStatus;
          context: {
            pipeline: activeMasterPipeline,
          }
        "
      >
      </ng-container>
    </h3>
  </div>
  <div class="pipeline-filter mb-0">
    <div class="form-group" *ngIf="masterPipelines && masterPipelines.length > 0">
      <label for="">Master Pipeline</label>
      <select
        class="form-control"
        [(ngModel)]="filter.masterPipelineId"
        (change)="setMasterPipeline()"
      >
        <option *ngFor="let p of masterPipelines" [value]="p.id">
          {{ p.label }}
        </option>
      </select>
    </div>
    <div class="form-group" *ngIf="activeMasterPipeline">
      <label for="">Pipeline</label>
      <select
        class="form-control"
        [(ngModel)]="filter.pipelineId"
        (change)="setPipeline()"
      >
        <option value="0">All</option>
        <option
          *ngFor="let p of activeMasterPipeline.child_pipelines"
          [value]="p.pipeline_id"
        >
          {{ p.pipeline.label }}
        </option>
      </select>
    </div>
    <div
      class="form-group"
      *ngIf="
        !activeMasterPipeline || (!masterPipelines && masterPipelines.length == 0)
      "
    >
      <label for="">Pipeline</label>
      <select
        class="form-control"
        [(ngModel)]="filter.pipelineId"
        (change)="setPipeline()"
      >
        <option *ngFor="let p of pipelines" [value]="p.id">
          {{ p.label }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="">Task Name</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filter.design_name"
        (keyup.enter)="setPipeline()"
      />
    </div>

    <div class="form-group">
      <label for="">Reference ID</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filter.id"
        (keyup.enter)="setPipeline()"
      />
    </div>

    <button class="btn btn-outline-info btn-sm m-1" (click)="resetFields()"
      ><i class="fas fa-eraser"></i> Reset Filters</button
    >

    <button
      (click)="showFilter = true"
      *ngIf="!showFilter"
      class="btn btn-info btn-sm m-1"
      >Show Advanced Filter</button
    >
    <button
      (click)="showFilter = false"
      *ngIf="showFilter"
      class="btn btn-info btn-sm m-1"
      >Hide Advanced Filter</button
    >
  </div>
</div>

<div class="pb-3" *ngIf="activePipeline || activeMasterPipeline">
  <div class="kt-widget filter align-items-center" *ngIf="showFilter">
    <div class="form-group mw-200">
      <label for="">Assignee</label>
      <ng-select
        [items]="staffService.assignee$ | async"
        [multiple]="true"
        [closeOnSelect]="true"
        bindLabel="firstname"
        bindValue="id"
        [searchable]="true"
        [(ngModel)]="filter.assignee"
        [hideSelected]="true"
        (change)="setPipeline()"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-label">
            {{ item.firstname }} {{ item.lastname }}
          </span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
            >×</span
          >
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          <div>{{ item.firstname }} {{ item.lastname }}</div>
        </ng-template>
      </ng-select>
    </div>

    <div class="form-group">
      <label for="">SKU / Product Name</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filter.sku"
        (keyup.enter)="setPipeline()"
      />
    </div>

    <div class="form-group">
      <label for="">Priority</label>
      <select
        type="text"
        class="form-control"
        [(ngModel)]="filter.design_priority"
        (change)="setPipeline()"
      >
        <option value="">All</option>
        <option value="10">Low</option>
        <option value="20">Medium</option>
        <option value="30">High</option>
      </select>
    </div>

    <div class="form-group">
      <label for="">Category</label>
      <ng-select
        [items]="pcatService._productCategories | async"
        bindValue="id"
        bindLabel="product_category"
        [(ngModel)]="filter.category_id"
        (change)="setPipeline()"
        multiple="true"
        [loading]="pcatService.gettingRecords"
      >
      </ng-select>
    </div>

    <div class="form-group">
      <label for="">Sub Category</label>
      <ng-select
        [items]="subcategorySvc._subCategories | async"
        bindValue="id"
        bindLabel="sub_category"
        [(ngModel)]="filter.subcategory_id"
        (change)="setPipeline()"
        multiple="true"
        [loading]="subcategorySvc.gettingRecords"
      >
      </ng-select>
    </div>

    <div class="form-group">
      <label for="">Tags</label>
      <ng-select
        [items]="tagSvc.formattedRecord$ | async"
        bindValue="id"
        [searchFn]="customTagsSearchFn"
        [(ngModel)]="filter.assigned_tags"
        (change)="setPipeline()"
        multiple="true"
        [loading]="tagSvc.gettingRecords"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
            >×</span
          >
          <span [innerHTML]="item.rawName" class="d-inline"></span>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          <h6 [innerHTML]="item.name"></h6>
        </ng-template>
      </ng-select>
    </div>

    <!-- <div class="form-group">
			<label for="">Due Date</label>
			<input type="date" class="form-control" [(ngModel)]="filter.due_date" (keyup.enter)="setPipeline()" (change)="setPipeline()" />
		</div> -->

    <div class="form-group">
      <label for="">Due Date From</label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="filter.date_from"
        (change)="setPipeline()"
      />
    </div>
    <div class="form-group">
      <label for="">Due Date To</label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="filter.date_to"
        (change)="setPipeline()"
      />
    </div>
  </div>
</div>

<div
  class="design-list-container"
  *ngIf="activePipeline && activePipeline.id && activePipeline.pipeline_type == 1"
>
  <div class="columns" cdkDropListGroup>
    <div
      class="column"
      *ngFor="
        let stage of activePipeline.stages | orderBy: ['order'];
        let i = index
      "
    >
      <h5 class="title">
        <div class="count pull-right">
          <!-- {{ stage.count }} -->
          <button mat-button [matMenuTriggerFor]="stageMenu">
            <i class="flaticon-more-1"></i>
          </button>
          <mat-menu #stageMenu="matMenu">
            <button mat-menu-item (click)="sortStage(stage, 'priority')"
              ><i class="fas fa-sort-amount-down"></i> Sort by priority</button
            >
            <button mat-menu-item (click)="sortStage(stage, 'due_date')"
              ><i class="fas fa-sort-amount-down"></i> Sort by due date</button
            >
            <!-- <button mat-menu-item (click)="sortStage(stage, 0)"><i class="fas fa-list"></i> Reset sorting</button> -->
          </mat-menu>
        </div>
        {{ stage.stage }}

        <h6 class="mb-0 p-0">
          <span
            class="pull-right pt-1"
            *ngIf="
              stage.records && stage.records.length > 0 && stage.completionStatus
            "
          >
            <b class="text-success"> <i class="fas fa-check-double"></i> </b> ({{
              (stage.completionStatus.completed / stage.completionStatus.total) *
                100 | currency: ' '
            }}%) | {{ stage.records.length }} CARDS
          </span>
          <div>
            <span>&nbsp;</span>
            <span
              class="assignee"
              *ngFor="let assignee of stage.assignees"
              title="{{
                assignee ? assignee.firstname + ' ' + assignee.lastname : ''
              }}"
            >
              {{ assignee ? assignee.firstname.charAt(0) : ''
              }}{{ assignee ? assignee.lastname.charAt(0) : '' }}
            </span>
          </div>
        </h6>
      </h5>

      <div>
        <div class="loading-designs text-center" *ngIf="stage.loading"
          ><i class="fas fa-spinner fa-spin"></i> Getting SKUs</div
        >

        <div
          *ngIf="!stage.loading"
          [perfectScrollbar]="{ wheelPropagation: true }"
          cdkDropList
          [id]="i"
          class="column-list"
          [cdkDropListData]="stage.records"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            class="column-item"
            cdkDrag
            [cdkDragDisabled]="authService.loginUser.prwx == 1"
            [cdkDragData]="design"
            *ngFor="let design of stage.records; let idx = index"
            [ngClass]="{
              high: getPriority(design) == 30,
              medium: getPriority(design) == 20,
              low: getPriority(design) == 10,
            }"
          >
            <div class="new-badge" *ngIf="calculateDateDiff(design.created_at) < 6">
              NEW!
            </div>

            <div class="row" *ngIf="design.attachment">
              <div class="col-md-12">
                <div class="text-center">
                  <img [src]="design.attachment" class="img-fluid img-thumbnail" />
                </div>
              </div>
            </div>

            <div class="my-2 product">
              <a
                href="javascript:;"
                title="View Details"
                class="link mr-1"
                (click)="showDetails(design, i)"
              >
                <span class="reference_id" *ngIf="design.id">
                  [{{ design.id }}]
                </span>
                <b>{{ design.design_name }}</b>
              </a>
            </div>

            <div class="action">
              <button mat-button [matMenuTriggerFor]="menu">
                <i class="flaticon-more-1"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editdesign(design, i)"
                  ><i class="fas fa-edit"></i> Edit</button
                >
                <button mat-menu-item (click)="deletedesign(design, i)"
                  ><i class="fas fa-trash text-danger"></i> Delete</button
                >
                <button mat-menu-item (click)="moveToOtherPipeline(design, i)"
                  ><i class="fas fa-stream"></i> Move to Pipelines</button
                >
              </mat-menu>
            </div>

            <div class="row">
              <div class="col-md-8 my-2">
                <div>
                  <span
                    class="due_date"
                    *ngIf="design.due_date"
                    [ngClass]="{
                      due: isDesignDue(design.due_date, design.mark_as_completed),
                      completed: isDesignCompleted(design.mark_as_completed),
                    }"
                  >
                    <i class="far fa-clock"></i>
                    {{ design.due_date | date: 'MMM d' }}
                  </span>

                  <span class="due_date" *ngIf="design.attachments_count">
                    <i class="fa fa-paperclip"></i> {{ design.attachments_count }}
                  </span>

                  <span
                    (click)="showDetails(design, i, 2)"
                    class="due_date completion-status"
                    *ngIf="
                      design.assigned_subtasks &&
                      design.assigned_subtasks.length > 0
                    "
                    [ngClass]="{
                      completed: isDesignSubtaskCompleted(design.assigned_subtasks),
                    }"
                  >
                    <i class="fa fa-check"></i>
                    {{ checkCompleteSubtask(design.assigned_subtasks) }}/{{
                      design.assigned_subtasks.length
                    }}
                  </span>
                  <span
                    class="tags"
                    *ngIf="
                      design.activePipeline &&
                      design.activePipeline.tag_ids &&
                      stage.tags &&
                      stage.tags.length > 0
                    "
                  >
                    <a
                      href="javascript:;"
                      *ngFor="let tag of stage.tags"
                      (click)="toggleTag(tag.id, design.activePipeline)"
                      [title]="tag.tag"
                    >
                      <span
                        [ngStyle]="{
                          color: isTagActive(tag.id, design.activePipeline.tag_ids)
                            ? tag.color
                              ? tag.color
                              : 'green'
                            : '',
                        }"
                      >
                        <mat-icon *ngIf="tag.icon">{{ tag.icon }}</mat-icon>
                        <b *ngIf="!tag.icon">{{ tag.tag[0] }}</b>
                      </span>
                    </a>
                  </span>
                </div>
              </div>
              <div class="col-md-4 my-2">
                <div
                  class="members"
                  *ngIf="design.assigned_users && design.assigned_users.length > 0"
                >
                  <span
                    *ngFor="let assignedUser of design.assigned_users"
                    title="{{
                      assignedUser.user
                        ? assignedUser.user.firstname +
                          ' ' +
                          assignedUser.user.lastname
                        : ''
                    }}"
                  >
                    <span class="user" *ngIf="assignedUser.user">
                      {{
                        (assignedUser.user
                          ? assignedUser.user.firstname.charAt(0)
                          : '') +
                          (assignedUser.user
                            ? assignedUser.user.lastname.charAt(0)
                            : '')
                      }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="mb-2"
              *ngIf="
                design.assigned_subtasks && design.assigned_subtasks.length > 0
              "
            >
              <ng-container
                *ngFor="let subtask of design.assigned_subtasks; let i = index"
              >
                <span
                  class="subtask-icon"
                  [ngStyle]="{ color: subtask.done ? 'green' : '' }"
                  (click)="markSubtaskAsCompleted(design, i, stage)"
                  *ngIf="subtask.icon"
                  [title]="subtask.text"
                >
                  <mat-icon>{{ subtask.icon }}</mat-icon>
                  <!-- <b *ngIf="!subtask.icon"></b> -->
                </span>
              </ng-container>
            </div>
            <div>
              <div class="form-check custom-checkbox">
                <input
                  [(ngModel)]="design.mark_as_completed"
                  (change)="markAsCompleted(design, i)"
                  class="form-check-input mark-as-completed"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault_{{ i + '_' + idx }}"
                />
                <label
                  class="form-check-label"
                  for="flexCheckDefault_{{ i + '_' + idx }}"
                >
                  Mark as Completed
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="master-pipeline-container"
  *ngIf="
    activeMasterPipeline &&
    activeMasterPipeline.id &&
    (!activePipeline || filter.pipelineId == 0)
  "
>
  <cnc-nd-master-pipeline-view
    [filter]="pipelineFilter"
    [pipelines]="pipelines"
    (setActivePipeline)="setActivePipeline($event)"
    (setMasterPipelineCompletion)="setMasterPipelineCompletion($event)"
    [activePipeline]="activeMasterPipeline"
  >
  </cnc-nd-master-pipeline-view>
</div>

<ng-template let-pipeline="pipeline" #completionStatus>
  <i class="fas fa-check-double"></i>
  <span *ngIf="pipeline.completionStatus">
    {{
      (pipeline.completionStatus.completed / pipeline.completionStatus.total) * 100
        | currency: ' '
    }}</span
  >
  <span *ngIf="!pipeline.completionStatus || pipeline.completionStatus.total == 0"
    >0</span
  >
  % Complete
</ng-template>
